import React from "react";
import CostSheetForm from "../../components/sales-manager/costsheet/CostSheetForm";

const CostSheet = () => {
    return <CostSheetForm />;
};

export default CostSheet;
